import {Stack, Typography, Divider} from "@mui/material";
import AdmsIdentifierDisplay from "./AdmsIdentifierDisplay";
import {MarkdownSection} from "../utils/landingPageSections";
import {isEmpty} from "../../config/commonFunctions";
import {keys} from "../../config/nameSpacesKeys";
import {useState} from "react";

export default function MsLanguageResourceItemDisplay(props) {
  const [mappings, setMappings] = useState(props.mappings);
  const [msLanguageResourceList, setMsLanguageResourceList] = useState(props.msLanguageResourceList);
  const {defaultLanguage, topLabel, normalizeBreaks} = props;

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }
  if (!msLanguageResourceList || msLanguageResourceList.length === 0) return null;

  return (
    <Stack sx={{pt: 1, pb: 2}} spacing={1}>
      <Typography variant="h4" gutterBottom noWrap sx={{pt: 1}}>{topLabel}</Typography>
      {msLanguageResourceList.map((item, index) => {
        const isLastElement = index === msLanguageResourceList.length - 1;
        return (
          <div key={index}>
            {item.title && !isEmpty(item.title.getValue(defaultLanguage)) && (
              <div>
                <Typography variant="body2" className={"key"}>{getLabel(keys.title, "title")}</Typography>
                <Typography variant="body1">{item.title.getValue(defaultLanguage)}</Typography>
              </div>
            )}
            {!isEmpty(item.description.getValue(defaultLanguage)) && (
              <MarkdownSection
                field={item.description}
                defaultLanguage={defaultLanguage}
                getLabel={getLabel}
                normalizeBreaks={normalizeBreaks}
                labelKey={keys.description}
                fallbackLabel="description"
              />
            )}
            <Stack sx={{pt: 1}} spacing={1}>
              <AdmsIdentifierDisplay defaultLanguage={defaultLanguage} mappings={mappings} admsIdentifierList={item.admsList} />
            </Stack>
            <Divider component="div" role="presentation" className={`dashed ${isLastElement ? "hide-divider" : ""}`} />
          </div>
        );
      })}
    </Stack>
  );
}
